export default __webpack_public_path__ + "static/media/Broad-Ocean Motor Product Catalogues.80619849.pdf";